<template>
  <div style="height:100%">
    <el-row class="vertical-center-box title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <!-- title slot -->
        <slot name="title">
            <span class="title-h4">{{isNil(title) ? "관리대상 목록" : title}}</span>
        </slot>
      </div>
      <div class="vertical-center-box">
        <w-check-obj-table-popup-button class="mr-r4" :type="type" :checked-obj-list="tableData" :managetype-data="managetypeData"
        :selected-managetype-id="selectedManagetypeId" :vm-template-flag="vmTemplateFlag" :show-interface-column="false" :show-netdevice-selection="showNetdeviceSelection"
        :except-define-ids="exceptDefineIds" :except-objtype-ids="exceptObjtypeIds" :obj-define-ids="objDefineIds" :objtype-ids="objtypeIds" :hiddenNetdeviceChildren="hiddenNetdeviceChildren"
        @change-obj-list="changeObjList"/>
        <w-header-search-button @click="showSearchTool = !showSearchTool" size="mini"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoaing" ref="table" :data="tableData" :columns="tableColumns" :column-default="columnDefault" :fit-height="fitHeight"
     :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="true" :style="fitHeight ? { height: '100%' } : null" />
  </div>
</template>
<script>
import { isNil, isEmpty, cloneDeep, map } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import WCheckObjTablePopupButton from '@/components/button/CheckObjTablePopupButton';
import LogicalGroupAPI from '@/api/settings/common/logical-group';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WCommonObjList',
  components: {
    WCheckObjTablePopupButton,
  },
  props: {
    fitHeight: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    // 논리:logical/물리:physical/논리-물리:both 테이블을 구분하는 변수
    type: {
      type: String,
      default: 'both',
    },
    // 기존에 선택된 관리대상 리스트
    checkedObjList: {
      type: Array,
      default: () => [],
    },
    // 제외할 objDefineId들을 배열로 정의한다
    exceptDefineIds: {
      type: Array,
      default: () => [],
    },
    // 제외할 objtypeId들을 배열로 정의한다.
    exceptObjtypeIds: {
      type: Array,
    },
    // 필터링할 objDefineId들을 배열로 정의한다.
    objDefineIds: {
      type: Array,
    },
    // 필터링할 objtypeId들을 배열로 정의한다.
    objtypeIds: {
      type: Array,
    },
    // 물리테이블 : 물리 테이블 영역의 관리구분 리스트, 따로 지정해주지 않으면 activeManagetypesToShow를 사용
    managetypeData: {
      type: Array,
      default: () => [],
    },
    // 물리테이블 : 물리 테이블 영역에서 특정 managetypeId만을 보여준다
    selectedManagetypeId: {
      type: String,
      default: null,
    },
    // 물리테이블
    vmTemplateFlag: {
      type: String,
      default: null,
    },
    // 물리테이블 : 권한관련 설정에서는 인터페이스가 필요가 없기때문에 인터페이스 컬럼을 보여주지 않는다
    showInterfaceColumn: {
      type: Boolean,
      default: true,
    },
    // 네트워크 장비를 부모로 가지는 관리 대상 숨김 여부
    hiddenNetdeviceChildren: {
      type: Boolean,
      default: false,
    },
    // 물리테이블 : 물리테이블에서 인터페이스 대상만을 선택하기 위한 변수 (selectedManagtypeId = "NMS" 로 하고 showNetdeviceSelection = false로 한다)
    showNetdeviceSelection: {
      type: Boolean,
      default: true,
    },
    // 컴포너트 활성화시 선택된 관리대상 목록을 조회
    loadObjList: {
      type: Boolean,
      default: false,
    },
    loadParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showSearchTool: false,
      isLoaing: false,
      tableData: [],
      columnDefault,
      tableColumns: [
        {
          prop: 'objName',
          label: '대상명',
          searchable: true,
          sortable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          width: 120,
          searchable: true,
          sortable: true,
          formatter: defaultFormatter,
        },
      ],
    };
  },
  watch: {
    active: {
      handler(to) {
        if (to) {
          this.loadData();
        } else {
          this.$nextTick(() => {
            this.initData();
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    isNil,
    /**
     * 컴포넌트 데이터 초기화
     * @author najong
     */
    initData() {
      this.$nextTick(() => {
        this.$refs.table.clearFilter();
      });
      this.showSearchTool = false;
      this.tableData = [];
    },
    loadData() {
      if (!isEmpty(this.checkedObjList)) {
        this.tableData = cloneDeep(this.checkedObjList);
      }
      if (this.loadObjList && !isEmpty(this.loadParams)) {
        this.isLoading = true;
        if (this.type === 'physical') {
          const params = {
            ...this.loadParams,
          };
          if (!isNil(this.selectedManagetypeId)) {
            params.managetypeId = this.selectedManagetypeId;
          }
          LogicalGroupAPI.getPhysicalObjList(params).then((response) => {
            const result = response.data;
            if (result.success) {
              this.tableData = result.data;
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리대상 목록', false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리대상 목록', false));
            this.tableData = [];
          }).finally(() => {
            this.isLoading = false;
          });
        } else {
          const params = {
            ...this.loadParams,
          };
          if (!isEmpty(this.exceptDefineIds)) {
            params.exceptDefineIds = this.exceptDefineIds;
          }
          LogicalGroupAPI.getLogicalObjList(params).then((response) => {
            const result = response.data;
            if (result.success) {
              this.tableData = result.data;
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리대상 목록', false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리대상 목록', false));
            this.tableData = [];
          }).finally(() => {
            this.isLoading = false;
          });
        }
      }
    },
    /**
     * checkObjTablePopup에서 선택한 objList를 TableData에 넣는다.
     * @author najong
     * @param  {Array} objList checkObjTablePopup에서 선택한 objList
     */
    changeObjList(objList) {
      this.tableData = cloneDeep(objList);
      this.$emit('change-obj-list', objList);
    },
    /**
     * 상위 컴포넌트에서 objList를 조회
     * @author najong
     * @param  {Boolean} toObjId 반환될 배열을 obj 객체로 할지 objId로 할지 선택 - default: 객체, true: objId
     * @return {Array} 선택된 obj객체/objId 리스트
     */
    getSelectedObjList(toObjIds) {
      if (!isNil(toObjIds) && toObjIds) {
        return map(this.tableData, 'objId');
      }
      return cloneDeep(this.tableData);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/table/CommonObjList.vue